        <div 
          *ngIf="componentDetails?.provider === 'productreview' && componentDetails?.enabled" 
          [id]="ratingId"
          [attr.data-theme]="componentDetails.theme">
        </div>

        <div 
          *ngIf="componentDetails?.provider === 'trustpilot' && componentDetails?.enabled"
          [id]="ratingId"
          class="trustpilot-widget"
          data-locale="en-GB"
          [attr.data-style-height]="componentDetails.height"
          data-style-width="100%"
          [attr.data-theme]="componentDetails.theme"
          data-stars="3,4,5"
          data-tags="SelectedReview"
          data-schema-type="Organization">
        </div>

        <div *ngIf="(componentDetails?.provider === 'defaqto' || !componentDetails?.provider) && componentDetails?.enabled">
          <open-svg-icon [name]="componentDetails.icon" [class]="[componentDetails.iconSize, 'height-auto']"></open-svg-icon>
        </div>